import _ from "lodash";

const isBlank = (str) => {
  return str == null || str == undefined || _.trim(str) === "";
};

const isNotBlank = (str) => {
  return !isBlank(str);
};

const currency = (number) => {
  if (isNaN(number)) return "";
  return Intl.NumberFormat("ko-Kr").format(number);
};

const replace = (str, target, replacement) => {
  if (isBlank(str)) return "";

  return str.split(target).join(replacement);
};

const codeNm = (codeArr, cdVl) => {
  if (!codeArr) return cdVl;

  const code = codeArr.find((item) => item.cdVl === cdVl);

  return code ? code.cdNm : cdVl;
};

const isValidPassword = (password) => {
  if (isBlank(password)) return false;

  const numRegx = /[0-9]+/;
  const alphaRegx = /[a-z]+/gi;
  const spclRegx = /[\\!\\@\\#\\$\\%\\^\\&\\*\\+\\=-]+/;
  const spaceRegx = /\s+/;

  // 길이 검증 8~15
  if (password.length < 8 || password.length > 15) return false;

  // 숫자 포함여부 검증
  if (!numRegx.test(password)) return false;

  // 알파벳 포함여부 검증
  if (!alphaRegx.test(password)) return false;

  // 특수문자자 포함여부 검증
  if (!spclRegx.test(password)) return false;

  // 공백 검증
  if (spaceRegx.test(password)) return false;

  return true;
};

const isValidEmail = (value) => {
  const EMAIL_REGX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;

  if (!value) return false;

  return EMAIL_REGX.test(value);
};

export default {
  isBlank,
  isNotBlank,
  currency,
  replace,
  codeNm,
  isValidPassword,
  isValidEmail,
};
